






import { Component, Vue } from 'vue-property-decorator';
import Mandelbrot from '@/components/Mandelbrot/Mandelbrot.vue';

@Component({
  components: {
    Mandelbrot
  }
})
export default class App extends Vue {}
